// Глобальный флаг: только что была перерисовка — не скрывать отчёт
let justReinitialized = false;

function hideBlocks() {
    // Если только что перерисовали фильтр — НЕ скрывать
    if (justReinitialized) {
        setTimeout(() => { justReinitialized = false; }, 100);
        return;
    }

    const BLOCK_SELECTOR = '.ti-relations-bottom-block';
    document.querySelectorAll(BLOCK_SELECTOR).forEach(el => {
        if (el.style.display !== 'none') {
            el.setAttribute('data-original-display', window.getComputedStyle(el).display || 'block');
        }
        el.style.display = 'none';
    });
}

function showBlocks() {
    const BLOCK_SELECTOR = '.ti-relations-bottom-block';
    document.querySelectorAll(BLOCK_SELECTOR).forEach(el => {
        const originalDisplay = el.getAttribute('data-original-display') || 'block';
        el.style.display = originalDisplay;
    });
}

var ais_relation_table_visibility_change = {
    init: function (isReinit = false) {
        const BLOCK_SELECTOR = '.ti-relations-bottom-block';
        const APPLY_BUTTON_SELECTOR = 'button[data-e="OnApplyFilter"]';

        const LIST_CONTAINER_ID = 'tifilter_ais_list_container';
        const DATE_FROM_ID = 'tifilter_filterperiod_dperiodfrom';
        const DATE_TO_ID = 'tifilter_filterperiod_dperiodto';
        const CHECKBOX_AIS_ID = 'tifilter_isatsaisoldformat';
        const CHECKBOX_AREA_ID = 'tifilter_isatsareaoldformat';
        const HIDDEN_AREA_ID = 'tifilter_atsselectedarea';
        const HIDDEN_AIS_ID = 'tifilter_atsselectedais';

        const OTHER_FILTER_SELECTORS = [
            '#tifilter_tirelationperiod',
            '#tifilter_relationformat',
            '#tifilter_titype',
            '#tifilter_calculationmode',
            '#tifilter_oremperspective',
            '#tifilter_codeap',
            '#tifilter_codeao',
            '#tifilter_coderp',
            '#tifilter_codero'
        ];

        const applyButton = document.querySelector(APPLY_BUTTON_SELECTOR);
        if (!applyButton) return;

        function setupFilterObservers() {
            const listContainer = document.getElementById(LIST_CONTAINER_ID);
            if (listContainer) {
                const obs = new MutationObserver(() => {
                    if (listContainer.children.length > 0) hideBlocks();
                });
                obs.observe(listContainer, { childList: true, subtree: true });
            }

            function patchValue(id) {
                const el = document.getElementById(id);
                if (!el) return;
                const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
                if (!desc?.set) return;
                Object.defineProperty(el, 'value', {
                    set(val) {
                        if (this.value !== val) {
                            desc.set.call(this, val);
                            hideBlocks();
                            this.dispatchEvent(new Event('input', { bubbles: true }));
                            this.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    },
                    get() { return desc.get.call(this); },
                    configurable: true,
                    enumerable: true
                });
            }

            [DATE_FROM_ID, DATE_TO_ID, HIDDEN_AREA_ID, HIDDEN_AIS_ID].forEach(patchValue);

            [CHECKBOX_AIS_ID, CHECKBOX_AREA_ID].forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    new MutationObserver(hideBlocks)
                        .observe(el, { attributes: true, attributeFilter: ['class'] });
                }
            });

            OTHER_FILTER_SELECTORS.forEach(selector => {
                const el = document.querySelector(selector);
                if (el) {
                    const event = el.tagName === 'SELECT' || (el.type === 'checkbox') ? 'change' : 'input';
                    el.addEventListener(event, hideBlocks);
                }
            });
        }

        applyButton.addEventListener('click', () => {
            hideBlocks();

            const blocks = document.querySelectorAll(BLOCK_SELECTOR);
            if (blocks.length === 0) return;

            const observer = new MutationObserver(() => {
                const hasContent = Array.from(blocks).some(block =>
                    block.children.length > 0 &&
                    block.querySelector('#tirelationstable_container')
                );

                if (hasContent) {
                    observer.disconnect();
                    showBlocks();
                }
            });

            blocks.forEach(block => {
                observer.observe(block, { childList: true, subtree: true });
            });
        });

        // При обычной инициализации — проверяем, нужно ли скрыть
        if (!isReinit) {
            const listContainer = document.getElementById(LIST_CONTAINER_ID);
            const areaListContainer = document.getElementById('tifilter_area_list_container');
            if ((listContainer && listContainer.children.length > 0) ||
                (areaListContainer && areaListContainer.children.length > 0)) {
                hideBlocks();
            }
        }

        setupFilterObservers();
    }
};

window.ais_relation_table_visibality_change = ais_relation_table_visibility_change;

// Функция для перерисовки
window.reinitAisRelationTableVisibility = function () {
    justReinitialized = true;
    // Сброс флага через 150 мс
    setTimeout(() => { justReinitialized = false; }, 150);

    if (window.ais_relation_table_visibality_change &&
        typeof window.ais_relation_table_visibality_change.init === 'function') {
        window.ais_relation_table_visibality_change.init(true);
    }
};